import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';
import { Blocks, Cable, Smartphone, Wrench } from 'lucide-react';

const icons = [Blocks, Wrench, Smartphone, Cable];

const Services = () => {
  const services = [
    {
      title: "Sistemas de gestión",
      description:
        "Organizá tu negocio y tené control total en tiempo real. Sistemas a medida para gestionar stock, ventas y procesos, accesibles desde cualquier lugar.",
      features: ["Stock", "Ventas", "Control en tiempo real", "Acceso remoto"],
    },
    {
      title: "Talleres y rubros técnicos",
      description:
        "Seguimiento completo de trabajos y clientes, con historial y alertas automáticas para no perder control ni información clave.",
      features: ["Órdenes de trabajo", "Seguimiento", "Alertas", "Historial"],
    },
    {
      title: "Aplicaciones móviles",
      description:
        "Accedé a tu sistema desde el celular, estés donde estés. Apps conectadas con sincronización en tiempo real.",
      features: ["Android", "Acceso móvil", "Tiempo real", "Carga en campo"],
    },
    {
      title: "Automatización e integraciones",
      description:
        "Conectamos herramientas y automatizamos procesos para reducir errores y eliminar tareas repetitivas.",
      features: ["Automatización", "Integraciones", "APIs", "Procesos"],
    },
  ];

  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-flex px-4 py-2 rounded-full bg-slate-100 text-slate-700 text-sm font-semibold mb-4">
            Soluciones digitales
          </span>

          <h2 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-4">
            Soluciones reales para problemas concretos
          </h2>

          <p className="text-xl text-slate-600">
            Cada sistema se diseña para ordenar tu trabajo, reducir errores y darte control en tiempo real, sin complicaciones.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {services.map((service, index) => {
            const Icon = icons[index] || Blocks;
            return (
              <Card
                key={service.title}
                className="border-slate-200 shadow-sm hover:shadow-xl transition-all duration-300 rounded-3xl"
              >
                <CardHeader>
                  <div className="w-14 h-14 rounded-2xl bg-blue-50 flex items-center justify-center mb-4">
                    <Icon className="h-7 w-7 text-blue-700" />
                  </div>

                  <CardTitle className="text-2xl text-slate-900">
                    {service.title}
                  </CardTitle>

                  <CardDescription className="text-base text-slate-600 leading-relaxed">
                    {service.description}
                  </CardDescription>
                </CardHeader>

                <CardContent>
                  <div className="flex flex-wrap gap-2">
                    {service.features.map((feature) => (
                      <Badge
                        key={feature}
                        variant="secondary"
                        className="bg-blue-50 text-blue-700 hover:bg-blue-100 rounded-full px-3 py-1"
                      >
                        {feature}
                      </Badge>
                    ))}
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;